// glode-premium.js — copia di prototipo/assets/premium.js portata nel tema (P25, 09/09/2026).
// PRIMA modifica rispetto all'originale: il percorso delle immagini delle tile, che nel tema passa
// dagli asset di Shopify invece che da ../assets/img/. È la stessa correzione di percorso prevista
// per il CSS. Nient'altro è stato toccato: le funzioni sono quelle approvate.
// ATTENZIONE: montaTelaio() NON va chiamata nel tema — monta testata, piede e cassetto del prototipo,
// che qui sono quelli di Horizon. Le sezioni chiamano solo montaTiles, montaTutti e le recensioni.
// SECONDA modifica: i link alla scheda prodotto. Nel prototipo erano `prodotto.html?sku=X`, che su
// Shopify e' relativo e da /collections/all diventa /collections/prodotto.html?sku=X, cioe' 404.
// Ora passano da __glodeProdottoUrl, definita in glode-handle.js (mappa sku -> handle generata
// dallo store). La guardia qui sotto serve se quell'asset non fosse caricato: meglio il catalogo
// di un errore JavaScript che lascerebbe la griglia vuota.
if (typeof window.__glodeProdottoUrl !== 'function') {
  window.__glodeProdottoUrl = function () { return '/collections/all'; };
}
function __glodeImg(rel) {
  // Un percorso che arriva da Shopify e' gia' un indirizzo completo della CDN: rimapparlo
  // sugli asset del tema lo romperebbe. Si rimappa solo il percorso relativo del prototipo.
  const v = String(rel || '');
  if (/^https?:\/\//.test(v) || v.startsWith('//')) return v;
  const file = v.split('/').pop().replace(/\.png$/, '.jpg');
  return (window.GLODE_ASSET_BASE || '../assets/img/') + file;
}
// premium.js — renderer della proposta premium Glodé (richiede prodotti-data.js caricato prima)
const P = window.GLODE_PRODOTTI || [];
const POPOLARI = ["GLOR32", "GLOR23", "GLOR21", "GLOR41"]; // selezione ⚠️DA-VALIDARE col cliente
const REGALO_SKUS = ["GLOR32", "GLOR23", "GLOR41", "GLOR52"]; // selezione ⚠️DA-VALIDARE col cliente
const TIPI_PELLE = ["Sensibile", "Secca", "Mista", "Matura", "Grassa", "Tendenza acneica"];
// ordine ufficiale dei prodotti per esigenza (MENU_SITO agg. 10/07)
const ORDINE_ESIGENZE = {
  'Detersione e esfoliazione': ['GLOR11', 'GLOR12', 'GLOR13'],
  'Idratazione': ['GLOR31', 'GLOR21', 'GLOR13', 'GLOR32'],
  'Pro aging': ['GLOR32', 'GLOR33', 'GLOR41', 'GLOR23', 'GLOR24'],
  'Macchie e discromie': ['GLOR33', 'GLOR12'],
  'Rughe e linee sottili': ['GLOR32', 'GLOR24', 'GLOR21'],
  'Nutrimento': ['GLOR23', 'GLOR24', 'GLOR33', 'GLOR41', 'GLOR32'],
  'Rughe occhi labbra': ['GLOR51', 'GLOR52'],
  'Purificante opacizzante': ['GLOR22'],
};
function ordinaPerEsigenza(lista, x) {
  const ord = ORDINE_ESIGENZE[x] || [];
  const ix = s => { const i = ord.indexOf(s); return i < 0 ? 99 : i; };
  return lista.slice().sort((a, b) => ix(a.sku) - ix(b.sku));
}
const perEsigenza = x => ordinaPerEsigenza(P.filter(p => p.esigenze.includes(x)), x);
// scatti ambientati UFFICIALI (Drive 17/07, fot. Manuela Bonci) — il primo è la vista principale in galleria
const FOTO_SCENA = {
  GLOR11: ['assets/img/scena-1-1.jpg', 'assets/img/scena-1-1-texture.jpg'],
  GLOR12: ['assets/img/scena-1-2.jpg', 'assets/img/scena-1-2-texture.jpg'],
  GLOR13: ['assets/img/scena-1-3.jpg'],
  GLOR21: ['assets/img/scena-2-1.jpg'],
  GLOR22: ['assets/img/scena-2-2.jpg'],
  GLOR23: ['assets/img/scena-2-3.jpg'],
  GLOR24: ['assets/img/scena-2-4.jpg'],
  GLOR31: ['assets/img/scena-3-1.jpg', 'assets/img/scena-3-1-texture.jpg'],
  GLOR32: ['assets/img/scena-3-2.jpg'],
  GLOR33: ['assets/img/scena-3-3.jpg'],
  GLOR41: ['assets/img/scena-4-1.jpg'],
  GLOR51: ['assets/img/scena-5-1.jpg'],
  GLOR52: ['assets/img/scena-5-2.jpg'],
};

// scatto d'atmosfera per categoria nel mega-menu (scatti ambientati ufficiali 17/07)
const MENU_SCENA = {
  'Detergenti': 'assets/img/scena-1-1.jpg',
  'Esfolianti': 'assets/img/scena-1-2.jpg',
  'Sieri': 'assets/img/scena-2-1.jpg',
  'Creme': 'assets/img/scena-3-2.jpg',
  'Maschere': 'assets/img/scena-4-1.jpg',
  'Contorno occhi e labbra': 'assets/img/scena-5-1.jpg',
};
const fmtE = n => n.toLocaleString('it-IT') + ' €';

// ---- Carrello a cassetto (design approvato 27/08: si apre all'aggiunta, barra 69 €, quantità/rimuovi,
// checkout disabilitato nel prototipo — su Shopify sarà il drawer nativo del tema, questo è il riferimento).
// Stato in memoria + sessionStorage (il multipagina ricarica a ogni pagina, il file unico no).
// Copy: quello ufficiale del cliente (TOV 07/07). toastCarrello() resta per compatibilità e apre il cassetto.
const SOGLIA_SPEDIZIONE = 69;
const CARRELLO = { righe: [] };
try { const s = sessionStorage.getItem('glode-carrello'); if (s) CARRELLO.righe = JSON.parse(s); } catch (e) {}
function carrelloSalva() { try { sessionStorage.setItem('glode-carrello', JSON.stringify(CARRELLO.righe)); } catch (e) {} }
function carrelloTotale() { return CARRELLO.righe.reduce((t, r) => t + r.prezzo * r.qty, 0); }
function carrelloPezzi() { return CARRELLO.righe.reduce((t, r) => t + r.qty, 0); }
function carrelloAggiungi(sku, formato, prezzo, qty = 1, msg, apri = true) {
  const p = P.find(x => x.sku === sku); if (!p) return;
  const f = formato || p.formato, pr = prezzo != null ? prezzo : p.prezzo;
  const r = CARRELLO.righe.find(x => x.sku === sku && x.formato === f);
  if (r) r.qty += qty; else CARRELLO.righe.push({ sku, formato: f, prezzo: pr, qty });
  carrelloSalva(); carrelloRender();
  if (apri) carrelloApri(msg || 'Aggiunto al carrello, la tua pelle ti ringrazierà.');
}
function carrelloRender() {
  const n = carrelloPezzi(), tot = carrelloTotale();
  document.querySelectorAll('.cart-n').forEach(el => el.textContent = n);
  const righe = document.getElementById('cassetto-righe'); if (!righe) return;
  righe.innerHTML = CARRELLO.righe.map((r, i) => { const p = P.find(x => x.sku === r.sku); return `
    <div class="cassetto-riga" data-i="${i}">
      <a class="cassetto-img" href="${__glodeProdottoUrl(r.sku)}"><img src="../${p.img}" alt=""></a>
      <div class="cassetto-info">
        <span class="cassetto-num">${p.numero}</span>
        <a class="cassetto-nome" href="${__glodeProdottoUrl(r.sku)}">${p.nome}</a>
        <span class="cassetto-formato">${r.formato} · ${fmtE(r.prezzo)}</span>
        <div class="cassetto-qty" role="group" aria-label="Quantità">
          <button type="button" data-delta="-1" aria-label="Diminuisci">−</button><span>${r.qty}</span><button type="button" data-delta="1" aria-label="Aumenta">+</button>
        </div>
      </div>
      <div class="cassetto-dx"><b>${fmtE(r.prezzo * r.qty)}</b><button type="button" class="cassetto-rimuovi">Rimuovi</button></div>
    </div>`; }).join('');
  document.getElementById('cassetto-vuoto').hidden = CARRELLO.righe.length > 0;
  document.getElementById('cassetto-piede').hidden = CARRELLO.righe.length === 0;
  document.getElementById('cassetto-subtotale').textContent = fmtE(tot);
  const manca = Math.max(0, SOGLIA_SPEDIZIONE - tot);
  document.getElementById('cassetto-soglia-testo').innerHTML = manca > 0
    ? `Aggiungi <b>${fmtE(manca)}</b> al carrello per la spedizione gratuita` : '<b>Spedizione gratuita inclusa</b>';
  document.getElementById('cassetto-soglia-barra').style.width = Math.min(100, tot / SOGLIA_SPEDIZIONE * 100).toFixed(1) + '%';
}
function carrelloApri(msg) {
  const c = document.getElementById('cassetto'); if (!c) return;
  const m = document.getElementById('cassetto-msg');
  m.textContent = msg || ''; m.hidden = !msg;
  clearTimeout(m._t); if (msg) m._t = setTimeout(() => { m.hidden = true; }, 3200);
  c.classList.add('aperto'); c.setAttribute('aria-hidden', 'false');
  document.getElementById('cassetto-velo').hidden = false;
  document.body.classList.add('cassetto-aperto');
  c.querySelector('.cassetto-chiudi').focus({ preventScroll: true });
}
function carrelloChiudi() {
  const c = document.getElementById('cassetto'); if (!c || !c.classList.contains('aperto')) return;
  c.classList.remove('aperto'); c.setAttribute('aria-hidden', 'true');
  document.getElementById('cassetto-velo').hidden = true;
  document.body.classList.remove('cassetto-aperto');
}
function toastCarrello(msg) { carrelloApri(msg); }
const CASSETTO_HTML = `
<div class="cassetto-velo" id="cassetto-velo" hidden></div>
<aside class="cassetto" id="cassetto" aria-label="Il tuo carrello" aria-hidden="true">
  <div class="cassetto-testa"><div><span class="eyebrow">Il tuo rituale</span><h2>Carrello (<span class="cart-n">0</span>)</h2></div><button class="cassetto-chiudi" type="button" aria-label="Chiudi il carrello">×</button></div>
  <p class="cassetto-msg" id="cassetto-msg" hidden></p>
  <div class="cassetto-soglia"><div id="cassetto-soglia-testo"></div><div class="soglia-barra"><span id="cassetto-soglia-barra"></span></div></div>
  <div class="cassetto-righe" id="cassetto-righe"></div>
  <div class="cassetto-vuoto" id="cassetto-vuoto">Il tuo carrello è vuoto.<br><a href="/collections/all">Scopri la linea</a></div>
  <div class="cassetto-piede" id="cassetto-piede" hidden>
    <div class="cassetto-totale"><span>Subtotale</span><b id="cassetto-subtotale">0 €</b></div>
    <p class="cassetto-nota">Spedizione e codici sconto calcolati al checkout · Reso facile entro 14 giorni</p>
    <button class="cta cta-blocco" type="button" id="cassetto-checkout" disabled>Vai al checkout</button>
    <p class="cassetto-demo">Prototipo: il checkout è quello nativo di Shopify e si attiva con lo store online.</p>
    <button class="link-inline" type="button" id="cassetto-continua">Continua lo shopping</button>
  </div>
</aside>`;
function montaCassetto() {
  document.body.insertAdjacentHTML('beforeend', CASSETTO_HTML);
  const c = document.getElementById('cassetto');
  c.addEventListener('click', e => {
    const riga = e.target.closest('.cassetto-riga'), i = riga ? +riga.dataset.i : -1;
    const q = e.target.closest('.cassetto-qty button');
    if (q && i >= 0) { CARRELLO.righe[i].qty += +q.dataset.delta; if (CARRELLO.righe[i].qty <= 0) CARRELLO.righe.splice(i, 1); carrelloSalva(); carrelloRender(); }
    else if (e.target.closest('.cassetto-rimuovi') && i >= 0) { CARRELLO.righe.splice(i, 1); carrelloSalva(); carrelloRender(); }
    else if (e.target.closest('.cassetto-chiudi, #cassetto-continua')) carrelloChiudi();
  });
  document.getElementById('cassetto-velo').addEventListener('click', carrelloChiudi);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') carrelloChiudi(); });
  // «Carrello (n)» in testata e nel menu mobile: nel multipagina l'href="#" salterebbe in cima, nel file unico
  // la difesa click del bootstrap lo neutralizza già; qui in ogni caso si apre il cassetto e basta.
  document.addEventListener('click', e => { if (e.target.closest('.cart-link')) { e.preventDefault(); carrelloApri(); } });
  addEventListener('hashchange', carrelloChiudi); // file unico: navigando a un'altra pagina il cassetto si chiude
  carrelloRender();
}

const tile = p => `<div class="tile">
  <div class="tile-media"><span class="tile-num">${p.numero}</span><img src="${__glodeImg(p.img)}" alt="${p.nome} — ${p.formato}" loading="lazy"><button type="button" class="cta-over" data-sku="${p.sku}" data-nome="${p.nome}" aria-label="Aggiungi al rituale: ${p.nome}">Aggiungi al rituale</button></div>
  <div class="tile-info"><a class="tile-nome" href="${__glodeProdottoUrl(p.sku)}">${p.nome}</a><span class="tile-prezzo">${fmtE(p.prezzo)}</span></div>
  <span class="tile-fam">${p.famiglia} · ${p.formato}</span></div>`;

// P38 (decisione di Mohamed, 10/09/2026): «Aggiungi al rituale» dalla piastrella, senza aprire la
// scheda. La piastrella è un collegamento: il clic sul bottone va fermato prima che il browser
// segua l'ancora (preventDefault e stopPropagation), altrimenti si aggiunge e si naviga insieme.
// L'id della variante: nel catalogo lo scrive il Liquid sulla piastrella (data-variante); dove la
// piastrella la costruisce questo file si chiede a /products/<handle>.js al momento del clic — una
// richiesta per piastrella premuta, non tredici al caricamento della pagina.
// L'evento CartLinesUpdate è quello che Horizon ascolta per aprire il cassetto e alzare il
// contatore: è la stessa strada della routine del test (glode-quiz-init.js).
function segnaAggiunto(bottone) {
  const prima = bottone.dataset.etichetta || bottone.textContent;
  bottone.dataset.etichetta = prima;
  bottone.textContent = 'Aggiunto ✓';
  bottone.disabled = true;
  setTimeout(() => { bottone.textContent = prima; bottone.disabled = false; }, 1400);
}
function erroreRituale(bottone, testo) {
  const tile = bottone.closest('.tile');
  let p = tile && tile.parentElement && tile.parentElement.querySelector(':scope > .tile-errore');
  if (!p && tile) { p = document.createElement('span'); p.className = 'tile-errore'; p.setAttribute('role', 'status'); tile.insertAdjacentElement('afterend', p); }
  if (p) p.textContent = testo;
}
async function varianteDaPiastrella(bottone) {
  if (bottone.dataset.variante) return Number(bottone.dataset.variante);
  const sku = bottone.dataset.sku;
  const handle = window.GLODE_HANDLE && window.GLODE_HANDLE[sku];
  if (!handle) throw new Error('prodotto non collegato allo store');
  const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
  if (!r.ok) throw new Error(`scheda non raggiungibile (${r.status})`);
  const p = await r.json();
  const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
  if (!v) throw new Error('nessuna variante disponibile');
  bottone.dataset.variante = v.id;
  return v.id;
}
document.addEventListener('click', async e => {
  const b = e.target.closest('.cta-over');
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  if (b.disabled) return;
  const etichetta = b.textContent;
  b.disabled = true;
  try {
    const id = await varianteDaPiastrella(b);
    const items = [{ id, quantity: 1 }];
    const aggiunta = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!aggiunta.ok) throw new Error(`il carrello ha risposto ${aggiunta.status}`);
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: items.map(i => ({ merchandiseId: String(i.id), quantity: i.quantity })),
        promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'glode-rituale', itemCount: cart.item_count, items: cart.items } }),
      }));
    } catch (err) {
      // senza l'evento il carrello è comunque aggiornato sul server: si aggiorna almeno il contatore
      document.querySelectorAll('.cart-n').forEach(el => { el.textContent = cart.item_count; });
    }
    b.disabled = false;
    segnaAggiunto(b);
    erroreRituale(b, '');
  } catch (err) {
    b.disabled = false;
    b.textContent = etichetta;
    erroreRituale(b, `Non sono riuscita ad aggiungere ${b.dataset.nome || 'il prodotto'} (${err.message}). Puoi aprire la scheda e aggiungerlo da lì.`);
  }
});

function montaTiles(sel, skus) {
  const el = document.querySelector(sel);
  if (el) el.innerHTML = skus.map(s => P.find(p => p.sku === s)).filter(Boolean).map(tile).join('');
}

function montaTutti(sel) {
  const el = document.querySelector(sel);
  if (el) el.innerHTML = P.map(tile).join('');
}

function skuCorrente() {
  // Nel tema la scheda e' /products/<handle>: il prodotto lo dichiara Liquid in
  // window.GLODE_SKU_CORRENTE. Il vecchio ?sku= resta come ripiego per il prototipo.
  const s = window.GLODE_SKU_CORRENTE || new URLSearchParams(location.search).get('sku') || 'GLOR32';
  return P.find(p => p.sku === s) || P.find(p => p.sku === 'GLOR32') || P[0];
}

// Cross-sell con fallback: stessa famiglia, poi i più amati (mai vuoto)
function crossSell(p, n = 3) {
  const stessa = P.filter(x => x.famiglia === p.famiglia && x.sku !== p.sku);
  const extra = POPOLARI.map(s => P.find(x => x.sku === s))
    .filter(x => x && x.sku !== p.sku && !stessa.includes(x));
  return stessa.concat(extra).slice(0, n);
}

// Menu del cliente (fonte: MENU_SITO_GLODE.xlsx dal Drive) — ordine e voci fedeli allo sheet
const FAMIGLIE_MENU = ['Detergenti', 'Esfolianti', 'Sieri', 'Contorno occhi e labbra', 'Creme', 'Maschere', 'Accessori'];
const ESIGENZE_MENU = ['Detersione e esfoliazione', 'Idratazione', 'Pro aging', 'Macchie e discromie', 'Rughe e linee sottili', 'Nutrimento', 'Rughe occhi labbra', 'Purificante opacizzante'];
// scatto del PRIMO prodotto dell'ordine ufficiale di ogni esigenza (ORDINE_ESIGENZE)
// infografiche «Attivi» fornite dal cliente (Drive «ATTIVI GLODE», 08/09/2026): una per SKU,
// 1080×1350 (4:5) su fondo bianco, nomi mappati sul campo `numero` (1.1 → attivi-1-1.jpg).
// Fondo bianco → mai prima vista della galleria; testo a ~5% dal bordo → sempre object-fit: contain.
const ATTIVI_IMG = Object.fromEntries(['1.1', '1.2', '1.3', '2.1', '2.2', '2.3', '2.4', '3.1', '3.2', '3.3', '4.1', '5.1', '5.2']
  .map(n => [`GLOR${n.replace('.', '')}`, `assets/img/attivi-${n.replace('.', '-')}.jpg`]));

const SCENA_ESIGENZA = {
  'Detersione e esfoliazione': 'assets/img/scena-1-1.jpg',
  'Idratazione': 'assets/img/scena-3-1.jpg',
  'Pro aging': 'assets/img/scena-3-2.jpg',
  'Macchie e discromie': 'assets/img/scena-3-3.jpg',
  'Rughe e linee sottili': 'assets/img/scena-3-2.jpg',
  'Nutrimento': 'assets/img/scena-2-3.jpg',
  'Rughe occhi labbra': 'assets/img/scena-5-1.jpg',
  'Purificante opacizzante': 'assets/img/scena-2-2.jpg',
};

// Centratura PER-SCATTO del prodotto nelle gallery delle varianti PDP (?variante=audrer|quadrata).
// Valori: misura automatica (scripts/qa/wrap-fuoco-misura.html) + correzione visiva dei centri
// (le foto con fasci di luce/ombre ingannano il rilevamento). pos = centro prodotto nella foto,
// z = zoom, tx/ty = traslazione in % del box per portare il prodotto al centro.
// a = box alto variante audrer (~620×840), q = box quadrato (~620×620). Su window: i template
// di pagina lo leggono come window.FUOCO_PDP.
// v45 (08/09): valori per il box 4:5 di audrer3 calcolati da scripts/qa/fuoco-valori.mjs --fill 0.55 --ratio 4:5
// sui bounding box MISURATI (scripts/qa/fuoco-bbox.js): prodotto alto il 55% del box e centrato in tutte le schede;
// le texture (senza prodotto) restano a zoom 1 centrate. Rigenerare con lo stesso comando se cambia il fill.
window.FUOCO_PDP = {
  'scena-1-1.jpg': { a: { pos: '47% 55%', z: 2.0,  tx: 3,   ty: -5 },  q: { pos: '47% 55%', z: 1.9,  tx: 3,   ty: -5 }, v45: { pos: '55.1% 57.6%', z: 1.44, tx: -5.08, ty: -15.89 } },
  'scena-1-2.jpg': { a: { pos: '50% 47%', z: 1.56, tx: 0,   ty: 3 },   q: { pos: '50% 47%', z: 1.37, tx: 0,   ty: 3 }, v45: { pos: '52.1% 50.9%', z: 1.02, tx: -0.89, ty: -9.28 } },
  'scena-1-3.jpg': { a: { pos: '52% 44%', z: 1.59, tx: -2,  ty: 6 },   q: { pos: '52% 44%', z: 1.24, tx: -2,  ty: 6 }, v45: { pos: '52.5% 54.1%', z: 1.04, tx: -2.05, ty: -9.01 } },
  'scena-2-1.jpg': { a: { pos: '50% 55%', z: 1.75, tx: 0,   ty: -5 },  q: { pos: '50% 55%', z: 1.4,  tx: 0,   ty: -5 }, v45: { pos: '45.8% 58.1%', z: 1.43, tx: 4.21, ty: -16.47 } },
  'scena-2-2.jpg': { a: { pos: '62% 60%', z: 1.9,  tx: -12, ty: -10 }, q: { pos: '62% 60%', z: 1.7,  tx: -12, ty: -10 }, v45: { pos: '59.5% 64.2%', z: 1.25, tx: -9.5, ty: -22.5 } },
  // 2-3: in orizzontale il cover non ha margine di crop → si centra con l'ASIMMETRIA dello scale:
  // O = (z·P − 50)/(z − 1) con P = centro prodotto MISURATO a pixel dal crop della cella (46%),
  // non stimato a occhio dalle thumbnail (che qui ingannano: correzioni andate al contrario per 3 giri)
  'scena-2-3.jpg': { a: { pos: '41% 48%', z: 1.7,  tx: 0,   ty: 2 },   q: { pos: '40% 48%', z: 1.6,  tx: 0,   ty: 2 }, v45: { pos: '50.4% 55.7%', z: 1.07, tx: -0.38, ty: -14.06 } },
  'scena-2-4.jpg': { a: { pos: '53% 58%', z: 2.0,  tx: -3,  ty: -8 },  q: { pos: '53% 58%', z: 1.73, tx: -3,  ty: -8 }, v45: { pos: '49.0% 57.3%', z: 1.42, tx: 1.04, ty: -15.58 } },
  'scena-3-1.jpg': { a: { pos: '45% 54%', z: 1.56, tx: 5,   ty: -4 },  q: { pos: '45% 54%', z: 1.3,  tx: 5,   ty: -4 }, v45: { pos: '51.4% 54.1%', z: 1.15, tx: -1.38, ty: -12.44 } },
  'scena-3-2.jpg': { a: { pos: '42% 51%', z: 2.0,  tx: 8,   ty: -1 },  q: { pos: '42% 51%', z: 1.9,  tx: 8,   ty: -6 }, v45: { pos: '49.7% 59.0%', z: 2.24, tx: 0.33, ty: -17.31 } },
  'scena-3-3.jpg': { a: { pos: '50% 52%', z: 2.0,  tx: 0,   ty: -2 },  q: { pos: '50% 52%', z: 1.9,  tx: 0,   ty: -6 }, v45: { pos: '49.5% 58.8%', z: 2.06, tx: 0.5, ty: -17.14 } },
  'scena-4-1.jpg': { a: { pos: '50% 58%', z: 2.0,  tx: 0,   ty: -8 },  q: { pos: '50% 58%', z: 1.86, tx: 0,   ty: -8 }, v45: { pos: '50.0% 59.1%', z: 1.69, tx: 0, ty: -17.39 } },
  'scena-5-1.jpg': { a: { pos: '47% 55%', z: 1.96, tx: 3,   ty: -5 },  q: { pos: '47% 55%', z: 1.53, tx: 3,   ty: -5 }, v45: { pos: '45.3% 50.8%', z: 1.16, tx: 4.75, ty: -9.17 } },
  'scena-5-2.jpg': { a: { pos: '46% 56%', z: 1.34, tx: 4,   ty: -6 },  q: { pos: '46% 56%', z: 1.04, tx: 4,   ty: -6 }, v45: { pos: '39.1% 48.3%', z: 1.07, tx: 2.82, ty: -8.1 } },
  'scena-1-1-texture.jpg': { a: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, q: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, v45: { pos: '50% 50%', z: 1.00, tx: 0, ty: -8.3 } },
  'scena-1-2-texture.jpg': { a: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, q: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, v45: { pos: '50% 50%', z: 1.00, tx: 0, ty: -8.3 } },
  'scena-3-1-texture.jpg': { a: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, q: { pos: '50% 55%', z: 1.05, tx: 0, ty: -5 }, v45: { pos: '50% 50%', z: 1.00, tx: 0, ty: -8.3 } },
};

// Fuoco verticale degli scatti 2:3 nella copertina orizzontale del mega-menu (riquadro ~612x356/381,
// rapporto 1,61-1,72: `cover` mostra solo il 39% dell'altezza della foto). Valori RICALCOLATI il 09/09
// dai bounding box MISURATI (scripts/qa/fuoco-bbox.js) perché il centro del prodotto cada al centro del
// riquadro: p = (cy·1,5·r − 0,5) / (1,5·r − 1), media dei due rapporti di riquadro. I valori precedenti,
// stimati a occhio, stavano 2-15 punti troppo in alto e tagliavano il fondo del prodotto — è la
// segnalazione del cliente in call 27/08 (00:08:37): «fare in modo che siano centrate […] in nutrimento
// il siero è tagliato». Verifica: scripts/qa/wrap-mega-verifica.mjs.
// In 4 scatti su 10 il prodotto è più alto del riquadro (1-2 116%, 2-3 110%, 3-1 103%, 5-1 102%):
// lì il taglio è inevitabile senza cambiare il riquadro e viene ripartito simmetricamente.
const FUOCO_SCENA = {
  'scena-1-1.jpg': '50% 63%', 'scena-1-2.jpg': '50% 52%', 'scena-2-1.jpg': '50% 64%',
  'scena-2-2.jpg': '50% 74%', 'scena-2-3.jpg': '50% 60%', 'scena-3-1.jpg': '50% 57%',
  'scena-3-2.jpg': '50% 65%', 'scena-3-3.jpg': '50% 65%', 'scena-4-1.jpg': '50% 65%',
  'scena-5-1.jpg': '50% 51%' };

// Mega-menu multipli (Prodotti, Esigenze) + tendine (Regalo, Metodo)
function montaMega() {
  const header = document.querySelector('.testata');
  if (!header) return;
  const toggles = [...header.querySelectorAll('[data-mega]')];
  const panels = [...header.querySelectorAll('.mega')];
  const ham = header.querySelector('.hamburger');
  const menuM = header.querySelector('.menu-mobile');
  function chiudiTutti() {
    panels.forEach(p => { p.hidden = true; });
    toggles.forEach(t => t.classList.remove('aperto'));
    if (menuM) { menuM.hidden = true; ham.classList.remove('aperto'); }
  }
  if (ham) ham.addEventListener('click', e => {
    e.stopPropagation();
    const apri = menuM.hidden;
    chiudiTutti();
    if (apri) { menuM.hidden = false; ham.classList.add('aperto'); }
  });
  // le voci di testata sono VERI LINK: il click naviga sempre (catalogo/metodo), il pannello
  // si apre al passaggio del mouse. Così i prodotti restano raggiungibili dal menu anche se il
  // pannello non si aprisse (segnalazioni cliente 07/08 e 18/08: «la scheda si apre solo dalla home»)
  toggles.forEach(t => t.addEventListener('mouseenter', () => {
    const panel = document.getElementById(t.dataset.mega);
    chiudiTutti();
    panel.hidden = false;
    t.classList.add('aperto');
  }));
  header.addEventListener('mouseleave', chiudiTutti);
  document.addEventListener('click', e => { if (!e.target.closest('.testata')) chiudiTutti(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') chiudiTutti(); });
  // SPA (file unico): la navigazione è un hashchange senza reload → il pannello aperto
  // sopravviverebbe sopra la nuova pagina. Chiudo al click su qualsiasi LINK della testata
  // (i .mega-tab sono <button>: esclusi, le tab restano usabili) e su hashchange
  // (copre anche il tasto Indietro). Niente stopPropagation/preventDefault: la "difesa
  // click" del file unico (capture su document che riscrive gli href) deve girare prima.
  header.addEventListener('click', e => { if (e.target.closest('a[href]')) chiudiTutti(); });
  addEventListener('hashchange', chiudiTutti);

  // pannello a tab riusabile (cambia al mouse over)
  function pannelloTab(idTabs, idTiles, voci, prodottiDi, scenaDi, hrefDi, vuotoDi) {
    const tabsEl = document.getElementById(idTabs);
    const tilesEl = document.getElementById(idTiles);
    if (!tabsEl || !tilesEl) return;
    let attiva = voci[0];
    function render() {
      tabsEl.innerHTML = voci.map(v =>
        `<button type="button" class="mega-tab${v === attiva ? ' attiva' : ''}" data-v="${v}">${v}</button>`).join('');
      const prods = prodottiDi(attiva);
      const scena = scenaDi(attiva);
      // fuoco come STILE INLINE calcolato dal nome file, MAI selettori CSS su src:
      // il build riscrive i src in data:URI e ucciderebbe il selettore (lo stile inline sopravvive)
      const fuoco = FUOCO_SCENA[scena.split('/').pop()] || '50% 55%';
      tilesEl.innerHTML =
        `<a class="mega-scena" href="${hrefDi(attiva)}"><img src="../${scena}" style="object-position:${fuoco}" alt="${attiva}"><span>${attiva} →</span></a>` +
        (prods.length ? prods.slice(0, 2).map(tile).join('') : `<p class="mega-vuoto">${vuotoDi ? vuotoDi(attiva) : 'In arrivo'}</p>`);
    }
    function cambia(e) {
      const b = e.target.closest('.mega-tab');
      if (b && b.dataset.v !== attiva) { attiva = b.dataset.v; render(); }
    }
    tabsEl.addEventListener('mouseover', cambia);
    tabsEl.addEventListener('click', cambia);
    render();
  }
  pannelloTab('tabs-prodotti', 'tiles-prodotti', FAMIGLIE_MENU,
    f => P.filter(p => p.famiglia === f),
    f => MENU_SCENA[f] || 'assets/img/hero-linea.png',
    f => '/collections/all?famiglia=' + encodeURIComponent(f),
    f => f === 'Accessori' ? 'Manopola e pennello — in arrivo' : 'In arrivo');
  pannelloTab('tabs-esigenze', 'tiles-esigenze', ESIGENZE_MENU,
    x => perEsigenza(x),
    x => SCENA_ESIGENZA[x] || 'assets/img/hero-linea.png',
    x => '/collections/all?esigenza=' + encodeURIComponent(x));
}

// ---- Telaio condiviso: annuncio + testata con mega-menu + footer, iniettati su ogni pagina ----
const TESTATA_HTML = `
<div class="annuncio">Spedizione gratuita da 69 € · Consegna in 5 giorni lavorativi</div>
<header class="testata">
  <div class="wrap testata-in">
    <button class="hamburger" type="button" aria-label="Apri il menu"><span></span><span></span></button>
    <nav class="testata-nav nav-sx">
      <a class="nav-shop" data-mega="mega-prodotti" href="/collections/all">Prodotti</a>
      <a class="nav-shop" data-mega="mega-esigenze" href="/collections/all">Esigenze</a>
      <a class="nav-shop" data-mega="mega-regalo" href="/collections/all?sel=regalo">Idee regalo e kit</a>
    </nav>
    <a class="testata-logo" href="/"><img src="../assets/img/logo.png" alt="Glodé"></a>
    <nav class="testata-nav nav-dx">
      <a href="/pages/scopri-il-tuo-codice">Scopri il tuo codice</a>
      <a class="nav-shop" data-mega="mega-metodo" href="/pages/metodo">Metodo &amp; Filosofia</a>
      <a href="#" class="cart-link">Carrello (<span class="cart-n">0</span>)</a>
    </nav>
  </div>
  <nav class="menu-mobile" hidden>
    <a href="/collections/all">Prodotti</a>
    <a href="/collections/all">Esigenze</a>
    <a href="/collections/all?sel=regalo">Idee regalo e kit</a>
    <a href="/pages/scopri-il-tuo-codice">Scopri il tuo codice</a>
    <a href="/pages/metodo">Metodo &amp; Filosofia</a>
    <a href="/pages/chi-siamo">Chi siamo</a>
    <a href="/pages/attivi-ricerca">Attivi &amp; ricerca</a>
    <a href="/pages/dove-trovarci">Dove trovi Glodé</a>
    <a href="#" class="cart-link">Carrello (<span class="cart-n">0</span>)</a>
  </nav>
  <div class="mega" id="mega-prodotti" hidden>
    <div class="wrap">
      <div class="mega-tabs" id="tabs-prodotti"></div>
      <div class="mega-tiles" id="tiles-prodotti"></div>
      <p class="mega-cta"><a class="cta cta-ghost-navy" href="/collections/all">Tutta la linea</a></p>
    </div>
  </div>
  <div class="mega" id="mega-esigenze" hidden>
    <div class="wrap">
      <div class="mega-tabs" id="tabs-esigenze"></div>
      <div class="mega-tiles" id="tiles-esigenze"></div>
      <p class="mega-cta"><a class="cta cta-ghost-navy" href="/collections/all">Filtra tutte le esigenze</a></p>
    </div>
  </div>
  <div class="mega mega-lista" id="mega-regalo" hidden>
    <div class="wrap mega-lista-in"><a href="/collections/all?sel=regalo">Kit prova</a><a href="/collections/all?sel=regalo">Idee regalo</a></div>
  </div>
  <div class="mega mega-lista" id="mega-metodo" hidden>
    <div class="wrap mega-lista-in"><a href="/pages/chi-siamo">Chi siamo</a><a href="/pages/metodo#metodo">Il nostro metodo</a><a href="/pages/attivi-ricerca">Attivi &amp; ricerca</a><a href="/pages/attivi-ricerca#risultati">Risultati reali</a></div>
  </div>
</header>`;

const PIEDE_HTML = `
<footer class="piede"><div class="wrap">
  <p class="piede-payoff">Recode your skin.<br><i>Recode yourself.</i></p>
  <div class="piede-cols">
    <div>
      <img class="logo-bianco" src="../assets/img/logo.png" alt="Glodé" style="height:40px;margin-bottom:16px">
      <p style="font-size:13px;opacity:.7;max-width:32ch">Dermo-cosmesi professionale. Panestetic Srl — Made in Italy.</p>
      <a href="/pages/chi-siamo" style="display:block;margin-top:10px;font-size:13px">Chi siamo</a>
    </div>
    <div>
      <h4>Prodotti</h4>
      <!-- FOOTER usato come "menu di riserva" dagli utenti che non riconoscono l'hamburger
           (Giada, 07/08 e 18/08: con zoom >=125% la barra sparisce e lei naviga dal footer).
           «Tutti i prodotti» ora porta al CATALOGO; prima «Tutta la linea» puntava a index#linea -->
      <a href="/collections/all">Tutti i prodotti</a><a href="/#amati">I più amati</a><a href="/collections/all?sel=regalo">Idee regalo</a><a href="/pages/scopri-il-tuo-codice">Scopri il tuo codice</a><a href="/pages/scopri-il-carico-esposomico">Test Longevity</a>
    </div>
    <div>
      <h4>Assistenza</h4>
      <a href="/pages/dove-trovarci">Dove trovi Glodé</a><a href="/pages/faq">FAQ</a><a href="/pages/policy?p=spedizioni">Spedizioni e consegne</a><a href="/pages/policy?p=resi">Resi e recessi</a><a href="/pages/policy?p=pagamenti">Metodi di pagamento</a><a href="/pages/policy?p=condizioni">Condizioni generali</a>
    </div>
  </div>
  <p class="piede-note">Prototipo — contenuti reali del brand, foto provvisorie. © Glodé · Panestetic Srl</p>
</div></footer>`;

function montaTelaio() {
  document.body.insertAdjacentHTML('afterbegin', TESTATA_HTML);
  document.body.insertAdjacentHTML('beforeend', PIEDE_HTML);
  montaMega();
  montaCassetto();
}

// ---- Catalogo (prodotti.html): tile premium + chip-filtri; legge famiglia/esigenza/pelle/sel dai query param ----
function montaCatalogoPremium() {
  const q = new URLSearchParams(location.search);
  const state = { famiglia: q.get('famiglia') || '', esigenza: q.get('esigenza') || '', pelle: q.get('pelle') || '', sel: q.get('sel') || '' };
  const wrap = document.querySelector('#catalogo');
  const filtri = document.querySelector('#filtri');
  const banner = document.querySelector('#banner-regalo');
  if (banner && state.sel !== 'regalo') banner.hidden = true;
  const FAM = [...new Set(P.map(p => p.famiglia))];
  const ESI = [...new Set(P.flatMap(p => p.esigenze))];
  const mappa = { 'Tipologia': 'famiglia', 'Esigenza': 'esigenza', 'Tipo di pelle': 'pelle' };
  const chips = (nome, lista, attivo) =>
    `<div class="filtro-gruppo"><span class="filtro-label">${nome}</span><span class="filtro-chips">` + lista.map(v =>
      `<button class="chip${v === attivo ? ' chip-attivo' : ''}" data-f="${nome}" data-v="${v === attivo ? '' : v}" type="button">${v}</button>`).join('') + `</span></div>`;
  function applica() {
    let out = P;
    if (state.sel === 'regalo') out = out.filter(p => REGALO_SKUS.includes(p.sku));
    if (state.famiglia) out = out.filter(p => p.famiglia === state.famiglia);
    if (state.esigenza) out = ordinaPerEsigenza(out.filter(p => p.esigenze.includes(state.esigenza)), state.esigenza);
    if (state.pelle) out = out.filter(p => p.tipo_pelle.includes(state.pelle));
    wrap.innerHTML = out.map(tile).join('') || '<p class="mega-vuoto" style="grid-column:1/-1">Nessun prodotto corrisponde ai filtri scelti</p>';
    const c = document.querySelector('#conteggio');
    if (c) c.textContent = `${out.length} ${out.length === 1 ? 'prodotto' : 'prodotti'}`;
    filtri.innerHTML = chips('Tipologia', FAM, state.famiglia) + chips('Esigenza', ESI, state.esigenza) + chips('Tipo di pelle', TIPI_PELLE, state.pelle);
  }
  filtri.addEventListener('click', e => {
    const b = e.target.closest('.chip');
    if (!b) return;
    state[mappa[b.dataset.f]] = b.dataset.v;
    applica();
  });
  applica();
}

// ---- FAQ (faq.html): categorie + fisarmonica (richiede faq-data.js) ----
function montaFaqPremium(selettore) {
  const el = document.querySelector(selettore);
  const FAQ = window.GLODE_FAQ || [];
  const cats = [...new Set(FAQ.map(f => f.categoria))];
  el.innerHTML = cats.map(c =>
    `<h2 class="titolo faq-cat">${c}</h2><div class="fisarmonica fisarmonica-domande">` +
    FAQ.filter(f => f.categoria === c).map(f =>
      `<details><summary>${f.domanda}</summary><p>${f.risposta}</p></details>`).join('') + `</div>`).join('');
}

// ---- Policy (policy.html): ?p=condizioni|pagamenti|spedizioni|resi + nav a chip (richiede policy-data.js) ----
function montaPolicyPremium() {
  const VOCI = { condizioni: 'Condizioni generali', pagamenti: 'Metodi di pagamento', spedizioni: 'Spedizioni e consegne', resi: 'Resi e recessi' };
  const chiave = new URLSearchParams(location.search).get('p') || 'condizioni';
  const pol = (window.GLODE_POLICY || {})[chiave] || window.GLODE_POLICY.condizioni;
  document.querySelector('#policy-titolo').textContent = pol.titolo;
  document.querySelector('#policy-corpo').innerHTML = pol.html;
  document.title = `${pol.titolo} — Glodé`;
  const nav = document.querySelector('#policy-nav');
  if (nav) nav.innerHTML = Object.entries(VOCI).map(([k, v]) =>
    `<a class="chip${k === chiave ? ' chip-attivo' : ''}" href="/pages/policy?p=${k}">${v}</a>`).join('');
}
